
import useCar from "../../node_modules/common/src/components/report/useCar";
import parking from "../../node_modules/common/src/components/report/parking";
import stay from "../../node_modules/common/src/components/report/stay";
import driving from "../../node_modules/common/src/components/report/driving";
import daily from "../../node_modules/common/src/components/report/daily";
import refuel from "../../node_modules/common/src/components/report/refuel";
import defuel from "../../node_modules/common/src/components/report/defuel";
import reportAssess from "@/components/report/reportAssess";
import personWorkReport from "@/components/report/PersonQualified";
import carWorkReport from "@/components/report/carWorks";
var data = [
  {
    path: "/useCar",
    component: useCar
  }, {
    path: "/stay",
    component: stay
  }, {
    path: "/parking",
    component: parking
  },
  {
    path: "/reportAssess",
    component: reportAssess
  },
  {
    path: "/personWorkReport",
    component: personWorkReport
  },
  {
    path: "/carWorkReport",
    component: carWorkReport
  },
  {
    path: "/driving",
    component: driving
  },
  {
    path: "/daily",
    component: daily
  },
  {
    path: "/refuel",
    component: refuel
  },
  {
    path: "/defuel",
    component: defuel
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/report.js